import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import styles from './FilterBar.styles';
import Icon from '../../common/icon/Icon';

class FilterBar extends Component {
  state = {
    currentTimeout: null,
    showScroll: false
  };
  componentDidUpdate() {
    let margin = 5;
    let children = Array.from(this.refs.bar.childNodes);
    let showScroll = this.state.showScroll;
    let barWidth = this.refs.bar.offsetWidth;
    let childrenWidth = children.reduce(
      (result, child) => result + child.offsetWidth + margin,
      0
    );
    if (barWidth <= childrenWidth) {
      if (!showScroll) {
        this.setState({ showScroll: true });
      }
    } else {
      if (showScroll) {
        this.setState({ showScroll: false });
      }
    }
  }
  renderFilter = (item, i) => {
    return (
      <span className={css(styles.item)} key={i}>
        {item.column || item.type} : {item.name || item.value}
        <Icon
          styles={styles.remove}
          value="cross"
          onClick={() => this.props.onRemove(item)}
        />
      </span>
    );
  };

  onEnterLeft = () => {
    let currentInterval = setInterval(() => {
      this.refs.bar.scrollLeft = this.refs.bar.scrollLeft - 4;
    }, 10);
    this.setState({ currentInterval });
  };

  onLeaveLeft = () => {
    clearInterval(this.state.currentInterval);
    this.setState({ currentInterval: null });
  };

  onEnterRight = () => {
    let currentInterval = setInterval(() => {
      this.refs.bar.scrollLeft = this.refs.bar.scrollLeft + 4;
    }, 10);
    this.setState({ currentInterval });
  };

  onLeaveRight = () => {
    clearInterval(this.state.currentInterval);
    this.setState({ currentInterval: null });
  };

  render() {
    const { styles: customStyles, items } = this.props;
    return (
      <div className={css(styles.base, customStyles)}>
        <Icon
          styles={[styles.left, !this.state.showScroll && styles.hide]}
          value="chevron-left"
          onMouseEnter={this.onEnterLeft}
          onMouseLeave={this.onLeaveLeft}
        />
        <div className={css(styles.bar)} ref="bar">
          {items && items.map(this.renderFilter)}
        </div>
        <Icon
          styles={[styles.right, !this.state.showScroll && styles.hide]}
          value="chevron-right"
          onMouseEnter={this.onEnterRight}
          onMouseLeave={this.onLeaveRight}
        />
      </div>
    );
  }
}

export default FilterBar;



// WEBPACK FOOTER //
// ./src/components/data/filterbar/FilterBar.js